// Порт приватной константы TaskStore (не экспортируется из store) — дефолтный тип задачи «звонок».
export const CALL_TASK_TYPE_ID = '92b6820d-b2a6-4f01-aa73-f05acc46343c';

// Порт TaskStore.updateKeys — поля, по которым строится diff в getTaskUpdateParams.
export const TASK_UPDATE_KEYS = ['executorIds', 'practiceIds', 'description', 'comment', 'type', 'urgency'] as const;

export enum TaskAssigneeType {
    Executors = 'executors',
    Practice = 'practice',
}
